import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserGroup, faRotate, faShieldAlt, faSearch } from "@fortawesome/free-solid-svg-icons";

// صفحات
import SearchAccountByPinCode  from "../../Pages/Search_Account_By_Pin_Code";
import Permission from "../../Pages/Permission";
import Account from "../../Pages/Account";
import Update from "../../Pages/Update";
const Routes = () => {
  const { t } = useTranslation();
  const routes = [

    {
      path: t("ACCOUNT"),
      name: t("ACCOUNT"),
      icon: <FontAwesomeIcon icon={faUserGroup} />,
      component: <Account />,
    },
    {
      path: t("Search_Account_By_Pin_Code"),
      name: t("Search_Account_By_Pin_Code"),
      icon: <FontAwesomeIcon icon={faSearch} />,
      component: <SearchAccountByPinCode  />,
    },
    {
      path: t("Permissions"),
      name: t("Permissions"),
      icon: <FontAwesomeIcon icon={faShieldAlt} />,
      component: <Permission />,
    },

    {
      path: t("UPDATES"),
      name: t("UPDATES"),
      icon: <FontAwesomeIcon icon={faRotate} />,
      component: <Update />,
    }
  ];
  return routes;
};

export default Routes;
